import { Flex } from 'antd';
import ThemeSwitcher from './themeSwitcher';
import DisplaySizeSwitcher from './displaySizeSwitcher';
import ThemeColorSwitcher from './themeColorSwitcher';

interface IAppearanceSettingsProps {
  /** Called after each change; the workspace setup leaves it out and closes on its own Done button. */
  onSubmit?: () => void;
}

const AppearanceSettings = ({ onSubmit }: IAppearanceSettingsProps) => (
  <Flex vertical gap={15}>
    <ThemeSwitcher onSubmit={onSubmit} />
    <DisplaySizeSwitcher onSubmit={onSubmit} />
    <ThemeColorSwitcher onSubmit={onSubmit} />
  </Flex>
);

export default AppearanceSettings;
